var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container dashboard"},[_c('h3',{staticClass:"dashboard__title"},[_vm._v("\n    ACCESS HISTORY\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }